import * as React from 'react';
import { ListInput, BaseComponentClass, BasicCompoClassProps } from '../generic/ListInput';
import { Form } from 'semantic-ui-react';
import { Conditions, ConditionalStateInput } from 'src/services/graphql/Models';

interface ConditionalStateInputsProps {
    onChange: (e: Event, data: {name: string, value: string}) => any;
    name: string;
    initialValue: any;
    isStateBased?: boolean;
    possibleStates?: string[];
}

const stateBasedConditionOption = [
    {
        key: Conditions.Equal,
        text: 'equal',
        value: Conditions.Equal,
    },
    {
        key: Conditions.NotEqual,
        text: 'unequal',
        value: Conditions.NotEqual,
    }
];

const valueBasedConditionOption = [
    {
        key: Conditions.Equal,
        text: 'equal',
        value: Conditions.Equal,
    },
    {
        key: Conditions.GreaterThan,
        text: 'greater than',
        value: Conditions.GreaterThan,
    },
    {
        key: Conditions.GreaterOrEqual,
        text: 'greater than or equal',
        value: Conditions.GreaterOrEqual,
    },
    {
        key: Conditions.LessThan,
        text: 'less than',
        value: Conditions.LessThan,
    },
    {
        key: Conditions.LessOrEqual,
        text: 'less than or equal',
        value: Conditions.LessOrEqual,
    }
];

class ConditionalState extends BaseComponentClass {
    
    render() {
        const { 
            condition,
            state,
            value
        } = this.state;
        const { isStateBased, possibleStates } = this.props;

        return (
            <div>
                <Form.Field>
                    <Form.Select
                        label="State Condition" 
                        onChange={this.changeHandler}
                        options={isStateBased ? stateBasedConditionOption : valueBasedConditionOption}
                        placeholder="Condition for the state" 
                        name="condition" 
                        defaultValue={condition} 
                    />
                </Form.Field>
                <Form.Field>
                    {isStateBased ? 
                        <Form.Select
                            label="Possible States" 
                            onChange={this.changeHandler}
                            options={possibleStates}
                            placeholder="Comparision type for the trigger" 
                            name="state" 
                            defaultValue={state} 
                        />
                        : <Form.Input 
                            placeholder="Trigger Value" 
                            label="Numeric Value"
                            name="value" 
                            defaultValue={value} 
                            onChange={this.changeHandler} 
                        />
                    }
                    
                </Form.Field>
            </div>
        );
    }
}

export default class ConditionalStateInputs extends React.Component<ConditionalStateInputsProps> {
    itemRenderer = this.toTrigger.bind(this);

    validate(_value: ConditionalStateInput): boolean | any {
        const { 
            value,
            state
        } = _value;
        
        let list: string[] = [];

        if (
            isNaN(Number(value))
            && !(
                typeof state  === 'string'
                && state.length > 0
            )
        ) {
            list.push('Please provide appropriate trigger value');
        }

        if (list.length > 0) {
            return {
                header: 'Validation Failed: ',
                list
            };
        } else {
            return true;
        }
        
    }

    handleValuesChange(values: any) {
        this.props.onChange({} as any, { name: this.props.name, value: values});
    }

    toTrigger(props: BasicCompoClassProps) {
        return (
            <ConditionalState 
                {...props}
                isStateBased={this.props.isStateBased}
                possibleStates={this.props.possibleStates}
            />
        );
    }

    render() {
        return (
            <ListInput
                initialValues={this.props.initialValue}
                defaultValue={() => {
                    return  {
                        condition: this.props.isStateBased ?
                         Conditions.Equal
                         : Conditions.GreaterOrEqual
                    };
                }}
                name={this.props.name}
                onValuesChange={this.handleValuesChange.bind(this)}
                validate={this.validate.bind(this)}
                Item={this.itemRenderer}
                StagingItem={this.itemRenderer}
                addButtonText="Add Conditional State"
            />
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/inputs/ConditionalState.tsx